import svgSpriteLoader from './svg-sprite-loader'

svgSpriteLoader()
